import { render, staticRenderFns } from "./AdminCreateSubGroup.vue?vue&type=template&id=8dd84b50&"
import script from "./AdminCreateSubGroup.vue?vue&type=script&lang=ts&"
export * from "./AdminCreateSubGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCreateSubGroup.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports